import { Component, OnInit, Input, ViewChild, inject, signal } from '@angular/core';
import { DeliveriesService } from '../../services/deliveries.service';
import { Delivery, JsonDelivery } from '../../bo/delivery';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { DeliveryModaleComponent } from './delivery-modale/delivery-modale.component';
import Keycloak from 'keycloak-js';

@Component({
  selector: 'app-deliveries',
  templateUrl: './deliveries.component.html',
  styleUrls: ['./deliveries.component.scss'],
  standalone: false
})

export class DeliveriesComponent implements OnInit {
  @ViewChild('modalExport', { static: false }) modalExport: ModalDirective;

  @Input() tirId: number;

  deliveries = signal<Delivery[]>([]);
  deliverySelected: Delivery;
  arrowSortDate = false;
  modalRef: BsModalRef;
  private readonly keycloak = inject(Keycloak);

  constructor(
    private readonly deliveriesService: DeliveriesService, 
    private readonly modalService: BsModalService
  ) { }

  hasEditDeliveryRole(): boolean {
    return this.keycloak.hasRealmRole('edit_delivery');
  }

  ngOnInit() {
    this.refresh();
  }

  ngOnChanges() {
    this.refresh()
  }

  refresh() {
    this.deliveriesService.getDeliveriesByTirId(this.tirId).subscribe((res: Delivery[]) => {
      this.deliveries.set(res.sort((a, b) => new Date(b.startTime).getTime() - new Date(a.startTime).getTime()));
      console.log(this.deliveries());
    })
  }



  sortByDate() {
    this.arrowSortDate = !this.arrowSortDate
    let sort;
    if (!this.arrowSortDate) {
      sort = this.deliveries().sort((a, b) => new Date(b.startTime).getTime() - new Date(a.startTime).getTime());
    } else {
      sort = this.deliveries().sort((a, b) => new Date(a.startTime).getTime() - new Date(b.startTime).getTime());
    }
    this.deliveries.set([...sort]);
  }

  openModal(delivery: Delivery) {

    this.deliveriesService.getDeliveryByGuid(delivery.tirId, delivery.deliveryId).subscribe((jsonDelivery: JsonDelivery) => {
      this.deliverySelected = delivery;
      
      // Create object with properties that match the component's properties
      const initialState = {
        jsonDelivery: jsonDelivery,
        delivery: delivery
      };
      
      this.modalRef = this.modalService.show(DeliveryModaleComponent,
        {
          backdrop: true,
          ignoreBackdropClick: false,
          keyboard: false,
          class: 'modal-lg',
          animated: false,
          initialState: initialState as Partial<DeliveryModaleComponent>
        });

      this.modalRef.content.onClose.subscribe((result: boolean) => {
        if (result) {
          this.refresh();
        }
      });
    });
  }
}
